import { render, staticRenderFns } from "./fbaWarehousingWorkspace.vue?vue&type=template&id=dfc7638e&"
import script from "./fbaWarehousingWorkspace.vue?vue&type=script&lang=js&"
export * from "./fbaWarehousingWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./fbaWarehousingWorkspace.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfc7638e')) {
      api.createRecord('dfc7638e', component.options)
    } else {
      api.reload('dfc7638e', component.options)
    }
    module.hot.accept("./fbaWarehousingWorkspace.vue?vue&type=template&id=dfc7638e&", function () {
      api.rerender('dfc7638e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/FBA/Warehousing/fbaWarehousingWorkspace.vue"
export default component.exports